import React from 'react';
import { IProductPrice, IComboPromotion } from 'types';
import { ProductPrice } from '@teko/teko-ecommerce';
import { useTenantConfig } from 'contexts';

interface ComboProductPriceProps {
  price: IProductPrice;
  promotion: IComboPromotion;
  textColor?: string;
}

export const ComboProductPrice: React.FC<ComboProductPriceProps> = ({
  price,
  promotion,
  textColor,
}) => {
  const { numberDisplayFormat, applyNewLogicToCalculateComboPrice } =
    useTenantConfig();
  const renderPrice = (price: IProductPrice) => {
    const latestPrice =
      applyNewLogicToCalculateComboPrice ||
      !promotion.condition?.exclusions?.length
        ? price.latestPrice
        : price.supplierRetailPrice;
    return (
      <ProductPrice
        latestPrice={latestPrice}
        supplierRetailPrice={
          price.supplierRetailPrice > latestPrice
            ? price.supplierRetailPrice
            : undefined
        }
        textColor={textColor}
        numberDisplayFormat={numberDisplayFormat}
      />
    );
  };

  return <>{renderPrice(price)}</>;
};
